import React, { Component } from 'react';
import { getStoreId, exhibitStoreId } from '../../../../utils/StoreConfigManager';
const storeId = getStoreId();
const arrowSVG = 'https://cdn.obsess-vr.com/umg/arrowImage.svg';

class MenuItem extends Component {
    constructor(props) {
        super(props);
        this.onHover = this.onHover.bind(this);
        this.onUnhover = this.onUnhover.bind(this);
        this.handleClick = this.handleClick.bind(this);

        this.state = {
            isHover: false
        }
    }

    onHover() {
        this.props.handleMouseOver();
        this.setState({ isHover: true });
        this.props.changeIndex();
    }

    onUnhover() {
        this.props.handleMouseOut();
        this.setState({ isHover: false });
    }

    handleClick(id) {
        this.props.handleClick(id)
    }

    render() {
        const { menuStyle, scene } = this.props;
        let sceneStyle = Object.assign({}, menuStyle);
        sceneStyle.color = this.state.isHover ? sceneStyle.hoverColor : sceneStyle.color;
        if(storeId === exhibitStoreId){
            sceneStyle.fontSize = '20px';
            sceneStyle.fontFamily = 'NeueHaasDisplayThin';
        }
        return (
            <div
                onMouseOver={this.onHover}
                onMouseOut={this.onUnhover}
                onClick={() => this.handleClick(scene.id)}
                className={`${storeId === exhibitStoreId? 'storeMenuItem': ''}`}
            >
                <span className="linked-store-scene" style={sceneStyle}> {scene.name.toUpperCase()} </span>
                <div className={`arrowSVG ${[2,3].includes(this.props.index) ? 'rotate' : ''}`}>
                    <img src={arrowSVG}/>
                </div>
            </div>
        )
    }
}

export default MenuItem;